import {RefObject, useEffect, useState} from "react";

interface IProps {
    defaultProgress: number;
    videoRef?: RefObject<HTMLVideoElement>;
}

export const useReelPlayerProgress = (props: IProps) => {
    const [progress, setProgress] = useState(props.defaultProgress);

    useEffect(() => {
        if (!props.videoRef?.current) {
            return;
        }

        const onTimeUpdate = () => {
            const video = props.videoRef?.current;

            if (video) {
                const newProgress = (video.currentTime * 100) / video.duration;
                setProgress(newProgress);
            }
        };

        props.videoRef.current.addEventListener("timeupdate", onTimeUpdate);

        return () => {
            props.videoRef?.current?.removeEventListener("timeupdate", onTimeUpdate);
        };
    }, [props.videoRef?.current]);

    return progress;
};
import {RefObject, useEffect, useState} from "react";

interface IProps {
    defaultProgress: number;
    videoRef?: RefObject<HTMLVideoElement>;
}

export const useReelPlayerProgress = (props: IProps) => {
    const [progress, setProgress] = useState(props.defaultProgress);

    useEffect(() => {
        if (!props.videoRef?.current) {
            return;
        }

        const onTimeUpdate = () => {
            const video = props.videoRef?.current;

            if (video) {
                const newProgress = (video.currentTime * 100) / video.duration;
                setProgress(newProgress);
            }
        };

        props.videoRef.current.addEventListener("timeupdate", onTimeUpdate);

        return () => {
            props.videoRef?.current?.removeEventListener("timeupdate", onTimeUpdate);
        };
    }, [props.videoRef?.current]);

    return progress;
};
